import React from "react";

// Assets 
import TongbaImg from "../../assets/optimized/tongba2.webp";
import GuitaristImg from "../../assets/optimized/guitarist.webp";
import LakesideCafeImg from "../../assets/optimized/lakeside-shore.webp";
import LakesideCafeMobileImg from "../../assets/optimized/lakeside-shore-mobile.webp";
import ResponsiveImg from "../ui/ResponsiveImg";

const lifestyleData = [
  {
    type: "The Reward",
    title: "Après-Trek",
    subtitle: "Because the best stories are told over Tongba.",
    image: TongbaImg,
    size: "md:col-span-5",
    position: "object-center"
  },
  {
    type: "The Social Soul",
    title: "Thamel Rhythms",
    subtitle: "Trade the sound of silence for live jazz.",
    image: GuitaristImg,
    size: "md:col-span-7",
    position: "object-center"
  },
  {
    type: "The Recovery",
    title: "Lakeside Echoes",
    subtitle: "A soft landing by the water before the journey home.",
    image: LakesideCafeImg, 
    mobileImage: LakesideCafeMobileImg,
    size: "md:col-span-12",
    position: "object-[center_85%]" 
  }
];

const LifestyleFeatures2 = () => {
  return (
    <section className="py-24 bg-[#FCFCFC] px-6 w-full border-t border-black/5">
      <div className="max-w-6xl mx-auto">
        
        {/* Header Section: Highlights the "Post-Summit" intent */}
        <div className="mb-14 md:mb-20 max-w-2xl">
          <h2 className="text-[#C99D89] uppercase tracking-[0.4em] text-[10px] font-bold mb-4">
            Post-Trail Recovery
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-[#575C3E] italic leading-tight">
            The summit is reached. <br/> Now, the stories begin.
          </h3>
          <p className="mt-6 text-[#575C3E]/70 font-light text-[15px] leading-relaxed max-w-lg">
            The journey isn't over when you leave the trail. It’s a 
            complete circle, from the rugged silence to the warmth 
            of a shared drink and the electric pulse of the city.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {lifestyleData.map((item, index) => (
            <div
              key={index}
              className={`relative group overflow-hidden rounded-[32px] ${item.size} h-[350px] md:h-[400px] shadow-sm`}
            >
              <ResponsiveImg
                src={item.image}
                mobileSrc={item.mobileImage}
                alt={item.title}
                className={`w-full h-full object-cover transition-transform duration-[3000ms] group-hover:scale-105 ${item.position}`}
                loading="lazy"
                decoding="async"
              />
              
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-90" />
              
              {/* Text Overlay */}
              <div className="absolute bottom-10 left-10 text-[#FCFCFC] max-w-[80%]">
                <span className="text-[9px] uppercase tracking-[0.4em] font-bold text-[#C99D89] mb-2 block">
                  {item.type}
                </span>
                <h4 className="text-3xl font-serif italic mb-2">
                  {item.title}
                </h4>
                <p className="text-[11px] uppercase tracking-widest font-light opacity-80 leading-relaxed">
                  {item.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LifestyleFeatures2;